import Const from 'constants';

const FlexMaxExposurePositions = {
    setFlexMaxExposurePositionsFromStorage(data) {
        return (dispatch) => {
            dispatch(this.setFlexMaxExposurePositions(data, {saveToStorage: false}));
        };
    },

    setFlexMaxExposurePositions(data, options = {}) {
        return (dispatch) => {
            const {saveToStorage = true} = options;

            dispatch({
                type: Const.SET_FLEX_MAX_EXPOSURE_POSITION,
                data,
            });

            saveToStorage && dispatch(
                this.saveDataToStorage('flexMaxExposurePositions', function (state) {
                    const {playersData} = state;

                    return playersData.flexMaxExposurePositions;
                }),
            );
        };
    },

    setSuperFlexMaxExposurePositionsFromStorage(data) {
        return (dispatch) => {
            dispatch(this.setSuperFlexMaxExposurePositions(data, {saveToStorage: false}));
        };
    },

    setSuperFlexMaxExposurePositions(data, options = {}) {
        return (dispatch) => {
            const {saveToStorage = true} = options;

            dispatch({
                type: Const.SET_SUPERFLEX_MAX_EXPOSURE_POSITION,
                data,
            });

            saveToStorage && dispatch(
                this.saveDataToStorage('superFlexMaxExposurePositions', function (state) {
                    const {playersData} = state;

                    return playersData.superFlexMaxExposurePositions;
                }),
            );
        };
    },
};

export default FlexMaxExposurePositions;
